import React from 'react';
import { useState } from 'react';
import { DotsHorizontalIcon } from 'shared/components/Icons';

const ActionButtons = ({ buttons, className = '' }) => {
  const [actionMenu, setActionMenu] = useState(false);

  const toggleActionMenuActive = e => {
    setActionMenu(!actionMenu);
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <div className={`action-buttons btn-count-${buttons.length} ${className || ''} ${actionMenu ? 'active' : ''}`}>
      <button className='btn p-0 action-btn action-btn-toggle' onClick={toggleActionMenuActive}>
        <DotsHorizontalIcon />
      </button>
      {buttons.map((item, i) => {
        if (item.hide) return null;

        // Support for custom components (like credit-gated buttons)
        if (item.customComponent) {
          return (
            <div key={i} className={`action-btn action-btn-${i + 1} ${item.className || ''}`}>
              {item.customComponent}
            </div>
          );
        }

        return (
          <button
            key={i}
            className={`btn p-0 action-btn action-btn-${i + 1} ${item.className || ''}`}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              item.onClick && item.onClick(e);
              setActionMenu(false);
            }}
          >
            {item.logo}
          </button>
        );
      })}
    </div>
  );
};

export default ActionButtons;
